module.exports = __webpack_public_path__ + "static/satelliteMap_Mobile-ab80db18bf97433e417c27f7ad64c827.jpg";